import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type ProjectRow } from '../api/client';

export function Dashboard() {
  const [projects, setProjects] = useState<ProjectRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.listProjects()
      .then((r) => setProjects(r.projects))
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
        <div>
          <h1>Dashboard</h1>
          <p className="muted" style={{ margin: 0 }}>Active bids and estimating pipeline.</p>
        </div>
        <Link className="btn btn-primary" to="/new">+ New Bid</Link>
      </div>

      {loading && <div className="muted">Loading projects…</div>}
      {error && <div className="error">{error}</div>}

      {!loading && !error && projects.length === 0 && (
        <div className="card">
          <h2>No bids yet</h2>
          <p className="muted">Create your first bid to begin. The AI reads the documents; your estimators do all counting.</p>
          <Link className="btn btn-gold" to="/new">Create a bid</Link>
        </div>
      )}

      {projects.length > 0 && (
        <div className="card" style={{ padding: 0 }}>
          <table>
            <thead>
              <tr>
                <th>Project</th><th>Customer</th><th>GC</th><th>County / State</th>
                <th>Bid date</th><th>Estimator</th><th>Status</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((p) => (
                <tr key={p.id}>
                  <td><Link to={`/projects/${p.id}`}>{p.name}</Link></td>
                  <td>{p.customer_name ?? '—'}</td>
                  <td>{p.gc_name ?? '—'}</td>
                  <td>{[p.county, p.state].filter(Boolean).join(', ') || '—'}</td>
                  <td>{p.bid_date ?? '—'}</td>
                  <td>{p.estimator ?? '—'}</td>
                  <td><span className={`pill pill-${p.status}`}>{p.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
